export default "__VITE_ASSET__BHwn3YJ0__"